<div class="column drawer-dialog">
	<div class="drawer-dialog-header display-flex-end">
		<h2 i18n="@@keyDetectionReportDialog-keyDetectionReport">Key Detection Report</h2>
		<button mat-icon-button>
			<mat-icon class="color-primary" (click)="onCloseDialog()" data-automation-id="key-detection-report-close-button"
				>close</mat-icon
			>
		</button>
	</div>

	<mat-dialog-content class="drawer-dialog-content">
		<h3 class="drawer-dialog-content-header" i18n="@@keyDetectionReportDialog-devices">Devices</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="devices-typeahead"
				[allDropdownOptions]="deviceOptions"
				[filterOnField]="'serialNumber'"
				[placeholderText]="this.deviceMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-add-user'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="deviceIds"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('device', $event)"
				(searchInputChanged)="onSearchInput('device', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		@if (this.isSentrilock) {
			<div>
				<mat-divider></mat-divider>
				<h3 class="drawer-dialog-content-header" i18n="@@keyDetectionReportDialog-deviceOwners">Device Owners</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="device-owners-typeahead"
						[allDropdownOptions]="deviceOwnerOptions"
						[filterOnField]="'name'"
						[placeholderText]="this.deviceOwnerMultiSelectorSearchPlaceHolder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-nav-work'"
						[initiallySelectedItemIds]="deviceOwnersCompanyIds"
						[initiallySelectedIdField]="'id'"
						[minCharactersForSearch]="3"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('deviceOwner', $event)"
						(searchInputChanged)="onSearchInput('deviceOwner', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>
		}

		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@keyDetectionReportDialog-accessByUser">Accessed By User</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="accessed-by-user-typeahead"
				[allDropdownOptions]="accessedByUserOptions"
				[filterOnField]="'displayName'"
				[placeholderText]="this.accessedByUserMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-add-user'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="accessedByUserIds"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('accessedByUser', $event)"
				(searchInputChanged)="onSearchInput('accessedByUser', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>

		<mat-divider></mat-divider>

		@if (isCareCompany) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientFirstName">Client First Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="first-name-typeahead"
						[allDropdownOptions]="firstNames"
						[filterOnField]="'firstName'"
						[placeholderText]="this.firstNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="firstName"
						[initiallySelectedIdField]="'firstName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('firstName', $event)"
						(searchInputChanged)="onSearchInput('firstName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientLastName">Client Last Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="last-name-typeahead"
						[allDropdownOptions]="lastNames"
						[filterOnField]="'lastName'"
						[placeholderText]="this.lastNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="lastName"
						[initiallySelectedIdField]="'lastName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('lastName', $event)"
						(searchInputChanged)="onSearchInput('lastName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientIdn">Client IDN</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="client-idn-typeahead"
						[allDropdownOptions]="clientIdns"
						[filterOnField]="'idn'"
						[placeholderText]="this.clientIdnMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="clientIdn"
						[initiallySelectedIdField]="'idn'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('clientIdn', $event)"
						(searchInputChanged)="onSearchInput('clientIdn', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>
		}

		<h3 class="drawer-dialog-content-header" i18n="@@keyDetectionReportDialog-propertyNames">Property Names</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="property-names-typeahead"
				[allDropdownOptions]="propertyOptions"
				[filterOnField]="'name'"
				[placeholderText]="this.propertyMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-lock'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="propertyIds"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('property', $event)"
				(searchInputChanged)="onSearchInput('property', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>

		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@assignDeviceControl-timeFrameHeader">Timeframe</h3>
		<div class="row" style="flex-wrap: nowrap">
			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@keyDetectionReportDialog-startDate">Start (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="startPicker"
					placeholder="Start (optional)"
					i18n-placeholder="@@keyDetectionReportDialog-chooseStartDate"
					(dateChange)="onStartDateChanged($event)"
					[ngModel]="this.keyDetectionReportFilters.visitStartDate"
					data-automation-id="start-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="startPicker"
					data-automation-id="start-date-toggle"
				>
				</mat-datepicker-toggle>
				<mat-datepicker #startPicker data-automation-id="start-date-datepicker"></mat-datepicker>
			</mat-form-field>

			<div style="display: flex; flex-direction: column; justify-content: center; padding: 0 24px">To</div>

			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@keyDetectionReportHeader-endDate">End (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="endPicker"
					placeholder="End (optional)"
					i18n-placeholder="@@keyDetectionReportDialog-chooseEndDate"
					(dateChange)="onEndDateChanged($event)"
					[ngModel]="this.keyDetectionReportFilters.visitEndDate"
					data-automation-id="end-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="endPicker"
					data-automation-id="end-date-toggle"
				>
				</mat-datepicker-toggle>
				<mat-datepicker #endPicker data-automation-id="end-date-datepicker"></mat-datepicker>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions class="margin-bottom-none">
		<div class="row content-flex-end">
			<div class="bottom-border"></div>
			<button
				mat-button
				class="secondary-button"
				(click)="onCloseDialog()"
				i18n="@@keyDetectionReportDialog-closeWindow"
				data-automation-id="key-detection-report-cancel-button"
			>
				Cancel
			</button>
			<button
				mat-button
				class="primary-button"
				style="margin-right: 24px"
				(click)="onGenerateReport()"
				data-automation-id="generate-key-detection-button"
			>
				{{ this.primaryButtonText }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
